if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        
        if (!this.elements.viewer) return;

        // Bind thumbnails click
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('.custom-thumbnail-item').forEach((thumb) => {
            thumb.addEventListener('click', () => {
              const mediaId = thumb.dataset.mediaId;
              this.setActiveMedia(mediaId);
            });
          });
        }
      }

      // Dawn native method called automatically on Variant Change
      setActiveMedia(mediaId) {
        if (!mediaId) return;

        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        // 1. Update active classes
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        // 2. Trigger Slick Slide Transition
        const $mainSlider = $(this.elements.viewer.querySelector('.product__media-list'));
        if ($mainSlider.length && $mainSlider.hasClass('slick-initialized')) {
          const $targetSlide = $mainSlider.find(`.product__media-item[data-media-id="${mediaId}"]`).not('.slick-cloned');
          if ($targetSlide.length) {
            const slickIndex = $targetSlide.data('slick-index');
            if (typeof slickIndex !== 'undefined') {
              $mainSlider.slick('slickGoTo', slickIndex);
            }
          }
        }

        // 3. Update active thumbnail state
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('.custom-thumbnail-item').forEach((thumb) => {
            thumb.classList.remove('is-active');
            if (thumb.dataset.mediaId === mediaId.toString()) {
              thumb.classList.add('is-active');
            }
          });
        }

        this.preventStickyHeader();
        this.playActiveMedia(activeMedia);
      }

      playActiveMedia(activeItem) {
        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
    }
  );
}